import { CommonError } from "lego-gui-lib";
import {
  RemoteChildDataSource,
  RemoteChildDataSourceOptions
} from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { RemoteListChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteListChildDataSource";
import { RemoteOneChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteOneChildDataSource";
import { action, observable } from "mobx";
import { ReactText } from "react";

export class ReportsDataSource<T, ID> extends RemoteChildDataSource<T, ID> {
  @observable public oneDataSource: RemoteOneChildDataSource<T, ID>;
  @observable public listDataSource: ReportsListDataSource<T, ID>;

  public constructor(options: RemoteChildDataSourceOptions) {
    super(options);
    this.listDataSource = new ReportsListDataSource<T, ID>(options);
    this.oneDataSource = new RemoteOneChildDataSource<T, ID>({ ...options });
  }

  public static create<T, ID>(
    options: RemoteChildDataSourceOptions
  ): RemoteChildDataSource<T, ID> {
    const it = new ReportsDataSource<T, ID>(options);

    it.listDataSource = new ReportsListDataSource(options);
    it.oneDataSource = new RemoteOneChildDataSource({ ...options });

    return it;
  }
}

export class ReportsListDataSource<T, ID> extends RemoteListChildDataSource<
  T,
  ID
> {
  @action
  public async getAsPdf(reportId: ReactText): Promise<void> {
    try {
      await this.api.fileDownload(`${this.url}/${reportId}/pdf`);
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    }
  }

  @action
  public async getAsCsv(reportId: ReactText): Promise<void> {
    try {
      await this.api.fileDownload(`${this.url}/${reportId}/csv`);
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    }
  }
}
